import React, { useState, useEffect } from "react";
import Navbar from "../../../../components/Navbar";
import SideBar from "../../../../components/SideBar";
import axios from "axios";
import { API_URL } from "../../../../constants/index";
import { toast } from "react-toastify";
import EditorComponent from "../../../../components/editor";
import { FaSpinner } from 'react-icons/fa';
import { GetServiceCaller, PostServiceCaller } from '../../../../services/serviceCaller';
import { useNavigate, useParams } from "react-router-dom";
const ManagerRemark = () => {
    const [pageTitle, setPageTitle] = useState('');
    const [icon, setIcon] = useState('fa fa-comment');
    const [pageLoading, setPageLoading] = useState(true);
    const [submitted, setSubmit] = useState(false);
    const { id } = useParams();



    let [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        manager_remark: '',
        employee_name:'',
        year:''
    });




    useEffect(() => {
        fetchData(id);
    }, []);




    const fetchData = async (id) => {
        try {
            setPageLoading(false);
            const response = await GetServiceCaller(`${API_URL}anniversary/${id}`);
           let anniversary =  {
            manager_remark: response.data.data.Manager_Remark,
                employee_name: response.data.data.Emp_name,
                year:response.data.data.Anniversary,
            }
            setFormData(anniversary);
        } catch (error) {
            console.error("Error fetching technology options:", error);
        }
    };





    const handleSubmit = async () => {
        setSubmit(true);
      try {
      
        const data = { ...formData };

        let response = await PostServiceCaller(`${API_URL}anniversary/${id}`, data, 'put');
          toast.success(response.data.message);
          setSubmit(false);

      } catch (error) {
        console.error("Error submitting form data:", error);
      }
    }
    const onEditorChange = (data) => {
        formData.manager_remark = data;
    }
    if (pageLoading) {
        return (
            <>
                <p class="position-absolute top-50 start-50 translate-middle text-center"><FaSpinner class="spinner" /></p>
            </>
        );
    } else {

        return (
            <>
                <div className="Nav">
                    <Navbar Title={pageTitle} Icon={icon} />
                </div>
                <div className="nest-page">
                    <SideBar />
                    <div className="Container" id="form-input-section">
                        <div className="mx-3">
                            <h3 className="heading skill-heading">
                                <i className="fa fa-user"></i> Work Anniversary Remark
                            </h3>
                        </div>


                        <form
                            onSubmit={handleSubmit}
                            id="formOne"
                            className="rounded bg-white"
                        >
                            <div className="card p-">
                                <div className="card-body">
                                    <div className="container-fluid">
                                        <div className="row ">
                                            <div className="col-sm-12">
                                                <p><strong>{formData.employee_name}</strong> is going to complete his <strong>{formData.anniversary==1?'first':'fifth'} </strong>work anniversary, please share your remark.</p>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label"> Manager Remark</label>
                                                    <EditorComponent data={formData?.manager_remark?formData?.manager_remark:''} onEditorChange={onEditorChange} />

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer text-muted">
                                    <div className="d-flex justify-content-end">
                                        <div className="d-flex">
                                            <button className="me-2 btn btn-info btn-sm">Cancel</button>                                             <button disabled={submitted ? true : false} onClick={handleSubmit} type="" className="btn btn-info">{submitted ? <FaSpinner class="sm-spinner" /> : 'Submit'}</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form >
                    </div >
                </div >
            </>
        );
    }
};

export default ManagerRemark;
